import {ApiResponseV2} from '../CommonInterfaces';
import {
  GetInboundLpnContentsFilters,
  GetInboundsFilters,
  PatchInboundRequest
} from '../../inbounds/shared/InboundInterfaces';
import InternalAPIServiceV2 from './InternalAPIServiceV2';

class InboundService extends InternalAPIServiceV2 {
  constructor() {
    super('/api/v2');
  }

  public async patchInboundById(id: number | string, patchInboundRequest: PatchInboundRequest): Promise<ApiResponseV2> {
    return await this.makePatchRequest(`${this.baseUrl}/inbounds/${id}`, patchInboundRequest);
  }

  public async getInbounds(filters: GetInboundsFilters): Promise<ApiResponseV2> {
    return await this.makeGetRequest(`${this.baseUrl}/inbounds`, filters, null, null, null, false);
  }

  public async getInboundById(id: number | string): Promise<ApiResponseV2> {
    return await this.makeGetRequest(`${this.baseUrl}/inbounds/${id}`);
  }

  public async getInboundSkuContentsById(id: number | string): Promise<ApiResponseV2> {
    return await this.makeGetRequest(`${this.baseUrl}/inbounds/${id}/contents/skus`);
  }

  public async getInboundLpnContentsById(
    id: number | string,
    filters: GetInboundLpnContentsFilters
  ): Promise<ApiResponseV2> {
    return await this.makeGetRequest(`${this.baseUrl}/inbounds/${id}/contents/lpns`, filters);
  }
}

export default InboundService;
